import ApplicationRecord from "./ApplicationRecord";
import TextSection from "./TextSection";
import ImageRecord from "./ImageRecord";
/**
 * Home page.
 *
 *
 */
export default class TextPage extends ApplicationRecord({
  /**
   * @type {Number}
   */
  ID: -1,
  /**
   * @type {String}
   */
  Path: "",
  /**
   * Absolute path.
   * @type {String}
   */
  URL: "",
  /**
   * @type {Boolean}
   */
  ShowInMenus: false,

  /**
   * @type {String}
   */
  Title: "",
  Content: "",
  /**
   * @type {String} SVG icon if needed for the navigation item
   */
  IconLink: "",
  /**
   * @type {'1 colonne' | '2 colonnes'}
   */
  SectionType: "1 colonne",
  CertificationTitle: "",

  /**
   * @type {Object}
   */
  _embedded: {},
}) {
  /**
   * Get the hero image
   * @return {ImageRecord}
   */
  heroCaption() {
    return "" + this._getOne("HeroText", String);
  }
  /**
   * Get the hero image
   * @return {ImageRecord}
   */
  heroImage() {
    return this._getOne("HeroImg", ImageRecord).set("alt", this.HeroCaption);
  }

  /**
   * Get the hero image for mobile screen
   * @return {ImageRecord}
   */
  heroMobileImage() {
    return this._getOne("HeroMobileImg", ImageRecord).set(
      "alt",
      this.HeroCaption
    );
  }
  /**
   * Get images for certification card
   * @return {ImageRecord}
   */
  certificationImages() {
    return this._getMany("CertificationMedias", (i) => new ImageRecord(i));
  }

  /**
   * @return {List<TextSection>}
   */
  sections() {
    return this._getMany("TextSections", (t) => new TextSection(t));
  }
}



// WEBPACK FOOTER //
// ./src/models/TextPage.js